import React from "react";

function Header() {
 
    return (
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                  
                    <span></span>
                  </h1>
                  <p>
                  
                  </p>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }

export default Header;
